import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, } from '@angular/forms';
import { TagInputModule } from 'ng2-tag-input';
import { MyDatePickerModule } from 'mydatepicker';
// import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import {SelectModule} from 'angular2-select';
import { TooltipModule } from 'ng2-tooltip';
import {TranslateModule} from 'ng2-translate';

import { ModalTaskModule } from '../../../work/modal/modal-task/modal-task.module';
import { IssueCreaterComponent } from './issue-creater.component';
import { ConfirmationModule } from '../../../../shared/modules/confirmation/confirmation.module';

@NgModule({
  imports: [
    CommonModule, 
    FormsModule,
    ReactiveFormsModule,
    MyDatePickerModule, 
    TagInputModule,
    // MultiselectDropdownModule,
    ModalTaskModule,
    ConfirmationModule,
    TooltipModule,
    SelectModule,
    TranslateModule],
  declarations: [IssueCreaterComponent],
  exports: [IssueCreaterComponent]
})
export class IssueCreaterModule { }


// WEBPACK FOOTER //
// ./src/app/modules/issues/shared/issue-creater/issue-creater.module.ts